import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postIssueFreespin = (params) => {
    return axios.post(`${backendHost}/api/admin/freespin/issue`, params);
};

export {
    postIssueFreespin
}